import {default as BaseApiClient} from './base'
import CommonUtil from '../utils/common'
import {API_BASE_URL} from '../defines/api'

export default class ApiApiClient extends BaseApiClient {

  static connectionTest (context, params) {
    const formData = new FormData()
    formData.append('key', context.$session.get('API_KEY'))
    formData.append('secret', context.$session.get('API_SECRET'))
    formData.append('channel', '1')
    formData.append('param', JSON.stringify({
      connection_id: params.connectionId,
      connection_name: params.connectionName,
      type: params.type,
      host: params.host,
      port: params.port,
      user: params.user,
      password: params.password,
      database: params.database,
      encoding: params.encoding,
      mode: params.mode,
      ssl_mode: params.sslMode,
      connection_test: true
    }))
    if (CommonUtil.isNotEmpty(params.sslCertFile)) {
      formData.append('ssl_cert_file', params.sslCertFile[0].raw,
        params.sslCertFile[0].name)
    }
    if (CommonUtil.isNotEmpty(params.sslKeyFile)) {
      formData.append('ssl_key_file', params.sslKeyFile[0].raw,
        params.sslKeyFile[0].name)
    }
    if (CommonUtil.isNotEmpty(params.sslCaFile)) {
      formData.append('ssl_ca_file', params.sslCaFile[0].raw,
        params.sslCaFile[0].name)
    }
    if (CommonUtil.isNotEmpty(params.privateKeyFile)) {
      formData.append('private_key_file', params.privateKeyFile[0].raw,
        params.privateKeyFile[0].name)
    }

    return this.post(context, 'connection', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest'
      },
      loadingMessage: '接続テスト中...',
      withCredentials: false
    })
  }

  static importDs (context, params) {
    const formData = new FormData()
    formData.append('key', context.$session.get('API_KEY'))
    formData.append('secret', context.$session.get('API_SECRET'))
    formData.append('channel', '1')
    formData.append('param', JSON.stringify({
      method: params.method,
      model_id: params.modelId,
      connection_id: params.connectionId,
      source_name: params.sourceName,
      table: params.table,
      sql: params.sql,
      file_path: params.filePath
    }))

    return this.post(context, 'ds/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest'
      },
      loadingMessage: 'インポート中...',
      withCredentials: false
    })
  }

  static reImportDs (context, params) {
    const formData = new FormData()
    formData.append('key', context.$session.get('API_KEY'))
    formData.append('secret', context.$session.get('API_SECRET'))
    formData.append('channel', '1')
    formData.append('param', JSON.stringify({
      method: params.method,
      model_id: params.modelId,
      import_id: params.importId
    }))

    return this.post(context, 'ds/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest'
      },
      loadingMessage: '再インポート中...',
      withCredentials: false
    })
  }

  static downloadDs (context, params) {
    const formData = new FormData()
    formData.append('key', context.$session.get('API_KEY'))
    formData.append('secret', context.$session.get('API_SECRET'))
    formData.append('channel', '1')
    formData.append('param', JSON.stringify({
      ds_name: params.dsName
    }))

    return this.post(context, 'ds/download', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest'
      },
      responseType: 'blob',
      withCredentials: false
    })
  }

  static BASE_URL = API_BASE_URL
}



// WEBPACK FOOTER //
// ./src/api/api.js